<template>
  <div :class="`${$style.detail} ${!hiddenTitle ? $style.detailT : ''}`">
    <header v-if="!hiddenTitle">
      <div @click="goBack">
        <i class="iconfont yw-xiangzuo"></i>
      </div>
      <span>{{ detailTitle }}</span>
    </header>
    <List
      v-model="loading"
      :finished="finished"
      finished-text="没有更多公告了"
      @load="onLoadNotice"
    >
      <div
        v-for="notice in noticeList.list"
        :key="notice.id"
        :class="$style.noticeBox"
        @click="onJumpDetail(notice)"
      >
        <div :class="$style.left">
          <p :class="$style.title">{{ notice.title }}</p>
          <p :class="$style.time">{{ notice.createTime }}</p>
        </div>
        <div :class="$style.detailBtn">
          <i class="iconfont yw-xiangyou"></i>
        </div>
      </div>
    </List>
  </div>
</template>

<script>
import { setPageTitle } from "@/bridge/AppJsBridge";
import { checkIsWxBrowser, getCookie } from "@/libs/utils";
import { getNoticeList } from "@/apis/gameSubscribe";
import { List } from "vant";
import { burnPoint } from "@/apis/heziShare";

export default {
  data() {
    return {
      detailTitle: "详情页",
      hiddenTitle: false,
      noticeList: { list: [] },
      loading: false,
      finished: true,
      cookie: null,
      id: null,
      activeName: "",
    };
  },
  created() {
    this.initData();
  },
  activated() {
    setPageTitle(this.detailTitle);
  },
  components: {
    List,
  },
  methods: {
    // 数据上报
    eventTrack(data) {
      if (!this.cookie) {
        return
      }
      // this.$toast(data.event);
      console.log("event: ", data.event);
      burnPoint({
        ...this.cookie,
        ...data,
      }).catch((err) => console.log(err));
    },
    async initData() {
      const { history } = this.$router;
      const { query } = history.current;
      const pageCookie = getCookie();
      const token = getCookie("token");
      if (token) {
        localStorage.setItem("token", token);
      }
      if (pageCookie) {
        for (const key in pageCookie) {
          if (
            Object.hasOwnProperty.call(pageCookie, key) &&
            pageCookie[key] === "null"
          ) {
            delete pageCookie[key];
          }
        }
        this.cookie = pageCookie;
        this.hiddenTitle = true;
      }
      setPageTitle(query.title);
      this.detailTitle = query.title || "公告列表";
      this.id = query.data;
      this.activeName = query.activeName;
      if (checkIsWxBrowser()) {
        this.hiddenTitle = true;
      }
      this.finished = false;
    },
    onLoadNotice() {
      if (!this.id) {
        this.finished = true;
        return;
      }
      let params = {
        current: this.noticeList?.currentPage || 1,
        id: this.id,
      };
      this.onGetNotice(params);
    },
    onGetNotice(data) {
      const { current = 1, size = 20, id } = data;
      getNoticeList({ current, size, id }).then((res) => {
        this.noticeList = res.data;
        this.loading = false;
        if (this.noticeList.total === this.noticeList.list.length) {
          this.finished = true;
        }
      });
    },
    onJumpDetail(data) {
      this.eventTrack({
        event: "appointment_notice_click",
        event_field: JSON.stringify({
          activity_id: this.id,
          activity_name: this.activeName,
          notice_id: data.id,
          notice_title: data.title,
        }),
      });
      this.$router.push({
        name: `box.noticeDetail`,
        query: {
          data: data.id,
          title: "公告详情",
        },
      });
    },
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" module>

.detailT{
  padding-top: 46px;
}
.detail {
  width: 100%;
  height: 100vh;
  max-width: 375px;
  margin: auto;
  background: #f1f1f1;
  overflow: auto;
  &.hiddenTitle {
    padding-top: 0px;
    > header {
      display: none;
    }
  }
  > header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    max-width: 375px;
    margin: auto;
    z-index: 3;
    background: #ffffff;
    color: #000000;
    font-size: 19px;
    padding: 14px 5px 14px 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > div {
      font-weight: bold;
      position: absolute;
    }
    > span {
      font-size: 18px;
      font-weight: 700;
      margin: 0 auto;
    }
    :global {
      .iconfont {
        font-size: 22px;
        margin-right: 5px;
      }
    }
  }
  .title {
    width: 100%;
    text-align: center;
    font-size: 20px;
    font-family: Source Han Sans CN, Source Han Sans CN-Bold;
    font-weight: 700;
    color: black;
    line-height: 36px;
  }
  :global {
    .iconfont {
      font-size: 22px;
      margin-right: 5px;
    }
  }
  .noticeBox {
    background: #ffffff;
    width: 361.11px;
    height: 69.79px;
    padding: 0 12.5px;
    align-items: center;
    display: flex;
    justify-content: space-between;
    border-radius: 6.94px;
    box-shadow: -0.35px 0px 7.29px 0.35px rgba(0, 0, 0, 0.03);
    margin: 12.65px auto 0;
    .left {
      .title {
        font-size: 14.58px;
        line-height: 1.5;
        font-weight: 500;
        text-align: center;
        color: #000000;
      }
      .time {
        font-size: 12.5px;
        font-weight: 400;
        text-align: left;
        color: #9f9f9f;
        line-height: 1.5;
      }
    }
    .detailBtn {
      width: 23.26px;
      height: 23.26px;
      background: linear-gradient(0deg, #fcbb19 0%, #ffcc56 100%);
      box-shadow: -1.82px 0px 5.56px 3.82px rgba(255, 201, 77, 0.36);
      border-radius: 50%;

      :global {
        .iconfont {
          font-size: 18px !important;
          margin-left: 4px;
          color: #ffffff;
          line-height: 23px;
        }
      }
    }
  }
}
</style>
